var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'wrapper__closed': true,
    'wrapper__closed--competition': (_vm.type === 'competition'),
    'wrapper__closed--vote': (_vm.type === 'vote'),
    'is-mac': _vm.isMac
}},[_c('div',{staticClass:"wrapper__container"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.dates[_vm.type])}})])])}
var staticRenderFns = []

export { render, staticRenderFns }